export default {
  data() {
    return {
      sidebar: '2',
      keyChange: 0,
      name: 'LottieFileComponent',
      props: {
        'tag': '',
        'width': '300px',
        'zIndex': 'auto', 'maxWidth': '500px',
        'height': '300px',

        'minHeight': '50px',
        'border': '0 none #000000',
        'boxShadow': '0 0 0 0 black initial',
        'background-color': '#000000',
        'backgroundImage': 'none',/*url("photographer.jpg"); The image used */
        'backgroundPosition': 'center', /* left top | left center | left bottom | right top | right center | right bottom | center top | center center | center bottom */
        'backgroundOrigin': 'border-box', /* padding-box|border-box|content-box Do not repeat the image */
        'backgroundRepeat': 'no-repeat', /*repeat | repeat-x | repeat-y | no-repeat | space | round   Do not repeat the image */
        'backgroundSize': 'cover', /* 'auto | 50% | 100% 100% | cover | contain  'Resize the background image to cover the entire container */
        'backgroundAttachment': 'scroll', /* scroll | fixed 'The background image will scroll or not scroll with the page' */
        'borderRadius': '0 0 0 0',
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',

        showDesktop: true,
        showMobile: true,
        hideDesktopOrder: 0,
        hideMobileOrder: 0,
      },
      elements: [],
      internal_config: {
        width: '300px',
        height: '300px',
        'minHeight': '50px',
        'zIndex': 'auto', 'maxWidth': '500px',
        background: '#FFFFFF',
        backgroundColor: '#FFFFFF',
        borderRadius: '0 0 0 0',
        'paddingTop': '15px',
        'paddingLeft': '15px',
        'paddingRight': '15px',
        'paddingBottom': '15px',

        url: '',
        code: '',
        speed: 1,
        autoplay: false,
        loop: false,
        controls: false,
        hideDesktopOrder: 0,
        hideMobileOrder: 0,
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/editor/apps/LottieFile/Model.js